<script lang="ts">
    import CloseIcon from "svelte-material-icons/Close.svelte"

    export let gallery: ImageEntry[] | undefined
    export let activeImage: ImageEntry | undefined
</script>

<div id="lightbox_gallery" class:active="{!!gallery}">
    <div class="inner">
        {#if gallery}
            <div class="lboxImage">
                <img
                    src="{(activeImage ? activeImage.file?.src : gallery && gallery[0]?.file?.src) + '?filter=l'}"
                    alt=""
                    loading="lazy"
                />
            </div>
            <div class="lboxList">
                {#each gallery as image, idx}
                    <div
                        class="lboxImage"
                        class:active="{activeImage == image || (!activeImage && idx == 0)}"
                        on:click="{() => {
                            activeImage = image
                        }}"
                    >
                        <img src="{image.file?.src}" alt="" loading="lazy" />
                    </div>
                {/each}
            </div>
            <div
                class="close"
                on:click="{() => {
                    gallery = undefined
                }}"
            >
                <CloseIcon size="24px" />
            </div>
        {/if}
    </div>
</div>

<style lang="less">
    @import "../../css/variables.less";

    #lightbox_gallery {
        position: fixed;
        top: initial;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 3000;
        background: rgba(0, 0, 0, 0.7);
        .transition();
        .opacity(0);
        visibility: hidden;
        .flex();
        flex-direction: column;
        .inner {
            position: absolute;
            top: 0px;
            bottom: 0px;
            left: 0px;
            right: 0px;
            background: var(--surface);
            color: var(--on-surface);
            // transform: scale(0);
            .transition();
        }
        &.active {
            .opacity(1);
            visibility: visible;
            /*.inner {
                transform: scale(1);
            }*/
        }
        .close {
            position: absolute;
            top: 20px;
            right: 20px;
            padding: 10px;
            cursor: pointer;
            line-height: 1;
        }
        .lboxImage {
            height: 80%;
            background: var(--surface);
            color: var(--on-surface);
            padding: 50px;
            @media (max-width: 768px) {
                padding: 5px;
            }
            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
        }
        .lboxList {
            height: 20%;
            background: var(--background);
            .flex();
            justify-content: center;
            padding: 20px;
            .lboxImage {
                .transition();
                width: 200px;
                height: 100%;
                margin: 0px 10px;
                padding: 10px;
                cursor: pointer;
                border: solid 2px var(--border-color-3);
                &:hover,
                &.active {
                    border-color: var(--primary);
                }
            }
        }
    }
</style>
